import { apiSlice } from "core/api";
import {
  CrossbarParticipation,
  CrossbarParticipationStatus,
  CrossbarParticipationWinner,
} from "crossbar/types/crossbar-participation.model";

const api = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    addCrossbarParticipation: build.mutation<
      { status: CrossbarParticipationStatus },
      CrossbarParticipation
    >({
      query: (body) => ({
        method: "POST",
        url: "crossbar-participations",
        body,
      }),
    }),
    getCrossbarParticipationWinners: build.query<
      { winners: CrossbarParticipationWinner[] | null },
      { crossbarEventId: string }
    >({
      query: ({ crossbarEventId }) => ({
        method: "GET",
        url: `crossbar-participations/${crossbarEventId}/winners`,
      }),
    }),
  }),
});

export const {
  useAddCrossbarParticipationMutation,
  useGetCrossbarParticipationWinnersQuery,
} = api;
